import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterRecargaCreditoView.
 * @extends JetView
 */
export default class FilterRecargaCreditoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get the current screen size

        /**
         * Converts a file to a Base64 string.
         * @param {File} file - The file to convert.
         * @returns {Promise<string>} A promise that resolves with the Base64 string.
         */
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader(); // FileReader to read file data
                reader.readAsDataURL(file); // Read file as data URL
                reader.onload = () => resolve(reader.result); // Resolve with result on load
                reader.onerror = (error) => reject(error); // Reject on error
            });
        }

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    cols: [
                        {
                            view: 'text', // Text input for client ID
                            name: 'Id',
                            type: 'number',
                            label: _('Numero del cliente:'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Numero del cliente:'), // Localized placeholder
                        },
                        {
                            view: 'text', // Text input for client ID card
                            name: 'Cedula',
                            label: _('Cedula del cliente:'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Cedula del cliente:'), // Localized placeholder
                        },
                        {
                            view: 'text', // Text input for client email
                            name: 'Email',
                            label: _('Email del cliente:'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Email del cliente:'), // Localized placeholder
                            invalidMessage: _('Campo No Valido'), // Invalid message
                        },
                        {
                            view: 'text', // Text input for client phone number
                            name: 'Phone',
                            label: _('Número de teléfono:'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Número de teléfono:'), // Localized placeholder
                            invalidMessage: _('Campo No Valido'), // Invalid message
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container', // CSS class for styling
            height: screen == 'small' ? 250 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };

        const datos = {
            // Sample data for demonstration
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav4', gravity: 3 }, // Placeholder for layout
                        {
                            view: 'button', // Button to load CSV
                            value: _('Cargar CSV'), // Localized button text
                            type: 'form',
                            width: screen == 'small' ? 0 : 200, // Conditional width based on screen size
                            minWidth: 200,
                            hidden: !devConfig.getPermAction('massiveMakeDeposit', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-massiveMakeDeposit', // CSS class for styling
                            click: () => {
                                // Click event handler
                                var base64CSV = ''; // Variable to store Base64 CSV data
                                webix
                                    .ui({
                                        view: 'window', // Window for CSV upload
                                        width: 450,
                                        height: 450,
                                        fullscreen: screen == 'small' ? true : false, // Fullscreen mode based on screen size
                                        head: {
                                            view: 'toolbar', // Toolbar for window header
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Recarga Masiva'), // Localized label
                                                },
                                                {
                                                    view: 'icon', // Close icon for window
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide window on close
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center', // Center the window
                                        modal: true, // Modal window
                                        body: {
                                            view: 'form', // Form inside the window
                                            id: 'addform2',
                                            elements: [
                                                {
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            view: 'uploader', // Uploader for CSV file
                                                            id: 'uploader',
                                                            value: _('Cargar archivo CSV'), // Localized uploader label
                                                            on: {
                                                                onBeforeFileAdd: function (upload) {
                                                                    // Event before file is added
                                                                    getBase64(upload.file).then((data) => {
                                                                        // Convert file to Base64
                                                                        base64CSV = data; // Store Base64 data
                                                                    });
                                                                    $$('uploader').define('label', upload.name); // Update uploader label
                                                                    $$('uploader').refresh(); // Refresh uploader
                                                                    var reader = new FileReader(); // FileReader to read file content
                                                                    reader.onload = function (event) {
                                                                        // On load event
                                                                        var records = event.target.result.split('\n'); // Split file content into records
                                                                        for (var i = 0; i < records.length; i++) {
                                                                            // Iterate through records
                                                                            var record = {}; // Create record object
                                                                            records[i] = records[i].split(';'); // Split record by semicolon
                                                                            for (
                                                                                var r = 0;
                                                                                r < records[i].length;
                                                                                r++
                                                                            ) {
                                                                                // Iterate through fields
                                                                                record['field' + (r + 1)] =
                                                                                    records[i][r]; // Assign field values
                                                                            }
                                                                            records[i] = record; // Update record
                                                                        }
                                                                        $$('dt1').clearAll(); // Clear existing data in datatable
                                                                        records = records.filter((item) => {
                                                                            // Filter out empty records
                                                                            return item.field1 != '';
                                                                        });
                                                                        $$('dt1').parse(records); // Parse new records into datatable
                                                                        $$('dt1').show(); // Show datatable
                                                                    };
                                                                    reader.readAsText(upload.file); // Read file as text
                                                                    return false; // Prevent default behavior
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: 'datatable', // Datatable to display uploaded records
                                                            id: 'dt1',
                                                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                                                            hidden: true, // Initially hidden
                                                            scrollY: true, // Enable vertical scrolling
                                                            height: screen == 'small' ? 0 : 200, // Conditional height based on screen size
                                                            columns: [
                                                                {
                                                                    id: 'field1',
                                                                    width: 220,
                                                                    header: _('Usuario'), // Localized header
                                                                },
                                                                {
                                                                    id: 'field2',
                                                                    header: _('Valor'), // Localized header
                                                                    fillspace: true, // Allow column to fill space
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button', // Cancel button
                                                            value: _('Cancelar'), // Localized button text
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Hide window on cancel
                                                                $$('addform2').setValues(
                                                                    $$('addform2').getCleanValues(),
                                                                ); // Reset form values
                                                                $$('uploader').define('label', _('Cargar archivo CSV')); // Reset uploader label
                                                                $$('uploader').refresh(); // Refresh uploader
                                                                base64CSV = ''; // Clear Base64 data
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button
                                                            type: 'form',
                                                            value: _('Guardar'), // Localized button text
                                                            click: function ($e) {
                                                                // Click event handler
                                                                var values = $$('addform2').getValues(); // Get form values
                                                                if ($$('addform2').validate() && base64CSV != '') {
                                                                    // Validate form and check Base64 data
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type for request
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Client/MassiveMakeDeposit', // API endpoint
                                                                            '{"CSV":"' + base64CSV + '"}', // Request body
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message('Error! '); // Show error message
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    text = JSON.parse(text); // Parse response
                                                                                    if (text.HasError) {
                                                                                        webix.message(
                                                                                            'Error: ' +
                                                                                                text.AlertMessage,
                                                                                        ); // Show error message
                                                                                    } else {
                                                                                        webix.message(
                                                                                            _(
                                                                                                'Recargas creadas correctamente',
                                                                                            ),
                                                                                        ); // Success message
                                                                                        let dataResult = text.Data; // Get data from response
                                                                                        webix
                                                                                            .ui({
                                                                                                view: 'window', // Window for summary
                                                                                                width: 450,
                                                                                                height: 450,
                                                                                                fullscreen:
                                                                                                    screen == 'small'
                                                                                                        ? true
                                                                                                        : false, // Fullscreen mode based on screen size
                                                                                                head: {
                                                                                                    view: 'toolbar', // Toolbar for window header
                                                                                                    cols: [
                                                                                                        {
                                                                                                            view: 'label',
                                                                                                            label: _(
                                                                                                                'Resumen de recargas',
                                                                                                            ), // Localized label
                                                                                                        },
                                                                                                        {
                                                                                                            view: 'icon', // Close icon for window
                                                                                                            icon: 'wxi-close',
                                                                                                            click: function () {
                                                                                                                this.getTopParentView().hide(); // Hide window on close
                                                                                                            },
                                                                                                        },
                                                                                                    ],
                                                                                                },
                                                                                                position: 'center', // Center the window
                                                                                                modal: true, // Modal window
                                                                                                body: {
                                                                                                    view: 'form', // Form inside the window
                                                                                                    elements: [
                                                                                                        {
                                                                                                            margin: 10,
                                                                                                            rows: [
                                                                                                                {
                                                                                                                    view: 'datatable', // Datatable for displaying summary
                                                                                                                    id: 'dt2',
                                                                                                                    css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                                                                                                                    scrollY: true, // Enable vertical scrolling
                                                                                                                    height:
                                                                                                                        screen ==
                                                                                                                        'small'
                                                                                                                            ? 0
                                                                                                                            : 200, // Conditional height based on screen size
                                                                                                                    columns:
                                                                                                                        [
                                                                                                                            {
                                                                                                                                id: 'UserId',
                                                                                                                                width: 110,
                                                                                                                                header: _(
                                                                                                                                    'Usuario',
                                                                                                                                ), // Localized header
                                                                                                                            },
                                                                                                                            {
                                                                                                                                id: 'Amount',
                                                                                                                                width: 110,
                                                                                                                                header: _(
                                                                                                                                    'Valor',
                                                                                                                                ), // Localized header
                                                                                                                            },
                                                                                                                            {
                                                                                                                                id: 'State',
                                                                                                                                header: _(
                                                                                                                                    'Estado',
                                                                                                                                ), // Localized header
                                                                                                                                fillspace: true, // Allow column to fill space
                                                                                                                            },
                                                                                                                        ],
                                                                                                                    data: dataResult, // Data for datatable
                                                                                                                },
                                                                                                            ],
                                                                                                        },
                                                                                                        {
                                                                                                            cols: [
                                                                                                                {
                                                                                                                    view: 'button', // Accept button
                                                                                                                    value: _(
                                                                                                                        'Aceptar',
                                                                                                                    ), // Localized button text
                                                                                                                    click: function () {
                                                                                                                        this.getTopParentView().hide(); // Hide window on accept
                                                                                                                    },
                                                                                                                },
                                                                                                            ],
                                                                                                        },
                                                                                                    ],
                                                                                                    elementsConfig: {
                                                                                                        on: {
                                                                                                            onChange:
                                                                                                                function () {
                                                                                                                    this.validate(); // Validate form on change
                                                                                                                },
                                                                                                        },
                                                                                                    },
                                                                                                },
                                                                                            })
                                                                                            .show(); // Show summary window
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Hide window after saving
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'), // Error title
                                                                        type: 'alert-error',
                                                                        text: _('Completa los campos...'), // Error message
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show window for CSV upload
                                $$('addform2').clearValidation(); // Clear validation on form
                            },
                        },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Localized button text
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the root view
                                $$('formRecargaCredito').hide(); // Hide the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Localized button text
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                $$('formRecargaCredito').hide(); // Hide the form
                                const filterdata = this.getRoot().getValues(); // Get filter data
                                const vthis = this; // Reference to the current context
                                if (
                                    (filterdata.Id !== '' && filterdata.Id !== undefined) ||
                                    (filterdata.Cedula !== '' && filterdata.Cedula !== undefined) ||
                                    (filterdata.Email !== '' && filterdata.Email !== undefined) ||
                                    (filterdata.Phone !== '' && filterdata.Phone !== undefined)
                                ) {
                                    webix.ajax().get(
                                        devConfig.geturlApi() + '/UserManagement/GetRecargaCredito', // API endpoint
                                        'Id=' +
                                            filterdata.Id +
                                            '&Cedula=' +
                                            filterdata.Cedula +
                                            '&Email=' +
                                            filterdata.Email +
                                            '&Phone=' +
                                            filterdata.Phone, // Query parameters
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message('Error! '); // Show error message
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                text = JSON.parse(text); // Parse response
                                                if (text.HasError) {
                                                    webix.message({
                                                        title: '¡Error!', // Error title
                                                        type: 'alert-error',
                                                        text: _(text.AlertMessage), // Error message
                                                    });
                                                } else {
                                                    vthis.app.callEvent('recargaCredito:data', [text.data]); // Call event with data
                                                    $$('FilterRecargaCredito').hide(); // Hide filter view
                                                    $$('formRecargaCredito').show(); // Show credit recharge form
                                                    $$('back-button').show(); // Show back button
                                                    $$('buttonDeposit').show(); // Show deposit button
                                                }
                                            },
                                        },
                                    );
                                } else {
                                    webix.message({
                                        text: _('Filtre Mínimo por un campo'), // Error message for minimum filter
                                        type: 'error',
                                        expire: 1000, // Message expiration time
                                    });
                                }
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main form view
            id: 'FilterRecargaCredito', // Unique ID for the form
            rows: [upper_section, buttons], // Rows containing upper section and buttons
            rules: {
                Email: webix.rules.isEmail, // Validation rule for email
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav4').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
